// extracted by mini-css-extract-plugin
export default {"sideBarElement":"style_sideBarElement__CouG6","sidenavCollapse":"style_sidenavCollapse__MQPvJ"};